import Vue from 'vue';
import VueRouter from 'vue-router';

import store from '../store'

import Home from '../views/Home';
import Login from '../views/Login';
import Register from '../views/Register';
import Documents from "../views/Documents";
import Document from "../components/Document";
import Community from "../components/Community";
import ColourGenerator from "../views/ColourGenerator";
import ForgotPassword from "../views/ForgotPassword";
import PasswordReset from "../views/PasswordReset";
import EDNA from "../components/EDNA";
import EmailVerify from "../views/EmailVerify";
import Learn from "../components/Learn";
import CommunityJoin from "../views/CommunityJoin";
import NotFound from "../views/NotFound";
import DocumentView from "../components/DocumentView";
import ProfileEdit from "../components/profile/ProfileEdit";
import AnalyticsPlanner from "../components/AnalyticsPlanner";
import TaskPopup from "../components/analytics-planner/TaskPopup";
import ProjectShare from "../components/ProjectShare";
import RequireLoginMessage from "../components/RequireLoginMessage";
import PrioritiesMatrix from "../components/priorities-matrix/PrioritiesMatrix";
import PrioritiesTaskPopup from "../components/priorities-matrix/PrioritiesTaskPopup";
import DocumentLimitReached from "../components/DocumentLimitReached";
import SubscriptionPlans from "../components/SubscriptionPlans";
import FeatureLocked from "../components/FeatureLocked";
// Teams
import Teams from "../components/Teams";
import Intro from "../components/teams/create/Intro";
import CreateTeam from "../components/teams/create/CreateTeam";
import TeamIndex from "../components/teams/TeamIndex";
import TeamJoin from "../components/teams/TeamJoin";
import SwitchTeam from "../components/teams/SwitchTeam";
import TeamMemberJoin from "../components/teams/TeamMemberJoin";
import SwitchToPersonalSpace from "../components/teams/SwitchToPersonalSpace";

// Projects
import Projects from "../components/projects/Projects";
import CreateIntro from "../components/projects/CreateIntro";
import CreateProjectForm from "../components/projects/CreateProjectForm";
import ProjectManagement from "../components/projects/ProjectManagement";
import ProjectView from "../components/projects/ProjectView";
import AddDocument from "../components/projects/AddDocument";

// Model planner
import ModelPlanner from "../components/model-planner/ModelPlanner";
import PipelinePlanner from "../components/pipeline-planner/PipelinePlanner";
import ModelTaskPopup from "../components/model-planner/ModelTaskPopup";
import Playlist from "../components/playlist/Playlist";

import ChatHome from '../components/chat/ChatHome';

import PowerBiTheme from '../components/powerBiThemesGenerator/PowerBiTheme';

Vue.use(VueRouter);

const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isLoggedIn) {
        next(vm => {
            vm.prevRoute = from
        })
        return
    }
    if (to.name == 'Require login' && localStorage.getItem('auth-app-path')) {
        next(localStorage.getItem('auth-app-path'));
        localStorage.removeItem('auth-app-path');
    } else {
        next('/apps')
    }

}

const ifAuthenticated = (to, from, next) => {
    if (store.getters.isLoggedIn) {
        next()
        return
    }
    let appsNames = [
        "Analytics Planner",
        "Priorities Matrix",
        "Project Share",
        "Data Model Planner",
        "Data Pipeline Planner",
    ];
    if (appsNames.includes(to.name)) {
        // store path it should go url
        localStorage.setItem('auth-app-path', to.path);
        next('/require-login')
    } else {
        next('/login');
    }
}

const ifCommunityMember = (to, from, next) => {
    if (!store.getters.isLoggedIn) {
        next('/login')
        return
    }
    let user = JSON.parse(localStorage.getItem('user'));
    if (user.free_plan) {
        next('/feature-locked')
        return
    }
    if (store.getters.isLoggedIn && user.community_member) {
        next()
        return
    }

    next('/community/join')
}

const ifFreeUser = (to, from, next) => {

    if (!store.getters.isLoggedIn) {
        if (to.name == 'Team Member Join') {
            next('/register?uuid=' + to.params.uuid);
            return;
        }
        next('/login')
        return
    }

    let user = JSON.parse(localStorage.getItem('user'));

    if (to.name != 'Team Member Join' && user.free_plan) {
        next('/feature-locked')
        return
    }
    next()
}


const router = new VueRouter({
    mode: 'history',
    routes: [
        { path: '/', redirect: to => { return '/'; } },
        { path: '/home', redirect: to => { return '/apps'; } },
        { path: '/apps/dev-priorities/*', redirect: to => { return '/apps/priorities-matrix/*'; } },
        { path: '*', component: NotFound },
        {
            path: '/apps',
            name: 'Apps Center',
            component: Home,
            meta: {
                requiresAuth: false,
                hideForAuth: false,
                svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n' +
                    '                        <g>\n' +
                    '                            <g>\n' +
                    '                                <g>\n' +
                    '                                    <path\n' +
                    '                                        d="M1.535 12.839l6.47 3.532c.23.125.507.125.735 0l6.47-3.532-1.914-1.045-3.82 2.085a2.3 2.3 0 0 1-2.206 0l-3.82-2.085zM3.45 7.955L1.535 9l6.47 3.532c.23.125.507.125.735 0L15.21 9l-1.914-1.045-3.82 2.085a2.3 2.3 0 0 1-2.206 0zM7.275.282a2.302 2.302 0 0 1 2.206 0l6.474 3.53c1.068.583 1.068 2.115 0 2.697l-1.047.571 1.047.572c1.068.582 1.068 2.114 0 2.696l-1.047.572 1.047.57c1.068.583 1.068 2.115 0 2.697l-6.474 3.531a2.302 2.302 0 0 1-2.206 0L.8 14.188c-1.067-.583-1.067-2.115 0-2.697l1.048-.571L.8 10.348C-.267 9.766-.267 8.234.8 7.652l1.048-.572L.8 6.51C-.267 5.926-.267 4.394.8 3.812zM8.74 1.629a.766.766 0 0 0-.735 0l-6.47 3.532 6.47 3.532c.23.125.507.125.735 0l6.47-3.532z"/>\n' +
                    '                                </g>\n' +
                    '                            </g>\n' +
                    '                        </g>\n' +
                    '                    </svg>'
            }
        },
        {
            path: '/community',
            name: 'Community',
            component: Community,
            beforeEnter: ifCommunityMember,
            meta: {
                requiresAuth: true,
                hideForAuth: false,
                svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n' +
                    '                        <g>\n' +
                    '                            <g>\n' +
                    '                                <g>\n' +
                    '                                    <path\n' +
                    '                                        d="M6.174 15.09c-.517-1.423-.848-3.29-.912-5.34H1.537a7.507 7.507 0 0 0 5.082 6.364 8.547 8.547 0 0 1-.445-1.024zm10.29-5.34h-3.726c-.065 2.05-.395 3.917-.912 5.34-.133.364-.28.709-.445 1.024a7.507 7.507 0 0 0 5.082-6.364zm-5.217 0H6.763c.064 1.908.373 3.595.822 4.828.255.698.54 1.211.82 1.535.281.326.487.387.6.387.114 0 .319-.06.6-.387.28-.324.565-.837.82-1.535.449-1.233.758-2.92.822-4.828zm5.216-1.5a7.507 7.507 0 0 0-5.082-6.364c.164.315.312.66.445 1.024.517 1.423.847 3.29.912 5.34zM9.005 1.5c-.113 0-.319.06-.6.387-.28.324-.565.837-.82 1.535-.449 1.233-.758 2.92-.822 4.828h4.484c-.064-1.908-.373-3.595-.822-4.828-.255-.698-.54-1.211-.82-1.535-.281-.326-.487-.387-.6-.387zM18 9A9 9 0 1 1 0 9a9 9 0 0 1 18 0zM1.537 8.25h3.725c.065-2.05.395-3.917.912-5.34.133-.364.28-.709.445-1.024A7.507 7.507 0 0 0 1.537 8.25z"/>\n' +
                    '                                </g>\n' +
                    '                            </g>\n' +
                    '                        </g>\n' +
                    '                    </svg>'
            }
        },
        {
            path: '/chat',
            name: 'The HUB',
            component: ChatHome,
            beforeEnter: ifAuthenticated,
            meta: {
                svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="22"><path d="M4.800005 21.90222272h-1.25l.75-1.02666669c.55-.78222224.949995-1.71111115 1.149995-2.9333334C1.899995 16.37777815 0 13.44444475 0 9.58222244 0 3.66667164 4.55001 0 11.9 0c7.35 0 11.9 3.66667164 11.9 9.58222244 0 5.96444458-4.45 9.58222244-11.9 9.58222244h-.5c-1.2 1.27111114-3.2 2.73777784-6.599995 2.73777784zM11.8 1.27111602c-6.65 0-10.600005 3.08000008-10.600005 8.31110642 0 4.44888899 2.80001 6.45333348 5.100005 7.38222239l.45.19555556-.05.4888889c-.15 1.12444447-.4 2.10222227-.8 2.9333334 2.4-.29333334 3.8-1.4666667 4.55-2.4444445l.2-.24444445h1.1c9.55 0 10.6-5.81777791 10.6-8.3111113.05-5.18221745-3.9-8.31110641-10.55-8.31110641z"/></svg>'
            },
            children: []
        },
        {
            path: '/documents',
            name: 'Documents',
            component: Documents,
            beforeEnter: ifAuthenticated,
            meta: {
                requiresAuth: true,
                hideForAuth: false,
                svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n' +
                    '                        <g>\n' +
                    '                            <g>\n' +
                    '                                <g>\n' +
                    '                                    <path\n' +
                    '                                        d="M2.25 0H7.5a.75.75 0 0 1 .53.22l5.25 5.25c.141.14.22.331.22.53v9.75A2.25 2.25 0 0 1 11.25 18h-9A2.25 2.25 0 0 1 0 15.75V2.25A2.25 2.25 0 0 1 2.25 0zm6 4.5c0 .414.336.75.75.75h1.94L8.25 2.56zm-6-3a.75.75 0 0 0-.75.75v13.5c0 .414.336.75.75.75h9a.75.75 0 0 0 .75-.75v-9H9A2.25 2.25 0 0 1 6.75 4.5v-3z"/>\n' +
                    '                                </g>\n' +
                    '                            </g>\n' +
                    '                        </g>\n' +
                    '                    </svg>'
            }
        },
        {
            path: '/document/:document_id',
            name: 'Document View',
            component: DocumentView,
            beforeEnter: ifAuthenticated,
            meta: {

            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            beforeEnter: ifNotAuthenticated,
            meta: {
                requiresAuth: false,
                hideForAuth: true,

            }
        },
        {
            path: '/register',
            name: 'register',
            component: Register,
            beforeEnter: ifNotAuthenticated,
            meta: {
                requiresAuth: false,
                hideForAuth: true,
            }
        },
        {
            path: '/forgot-password',
            name: 'Forgot Password',
            component: ForgotPassword,
            beforeEnter: ifNotAuthenticated,
            meta: {
                requiresAuth: false,
                hideForAuth: true,
            }
        },
        {
            path: '/password/reset',
            name: 'Password Reset',
            component: PasswordReset,
            beforeEnter: ifNotAuthenticated,
            meta: {
                requiresAuth: false,
                hideForAuth: true,
            }
        },
        {
            path: '/email/verify',
            name: 'Email Verification',
            component: EmailVerify,
            beforeEnter: ifNotAuthenticated,
            meta: {
                requiresAuth: false,
                hideForAuth: true,
            }
        },
        {
            path: '/apps/dax',
            name: 'Dax',
            component: Document,
            meta: {
                requiresAuth: false,
                hideForAuth: false,
            }
        },
        {
            path: '/apps/colour-generator',
            name: 'Colour generator',
            component: ColourGenerator,
            meta: {
                requiresAuth: false,
                hideForAuth: false,
            }
        },
        {
            path: '/apps/colour-generator/colours-fan',
            name: 'Colours Fan',
            component: Document,
            meta: {
                requiresAuth: false,
                hideForAuth: false,
            }
        },
        {
            path: '/apps/colour-generator/image-to-colours',
            name: 'Image to Colours',
            component: Document,
            meta: {
                requiresAuth: false,
                hideForAuth: false,
            }
        },
        {
            path: '/apps/colour-generator/colours-palette',
            name: 'Colours Palette',
            component: Document,
            meta: {
                requiresAuth: false,
                hideForAuth: false,
            }
        },
        {
            path: '/apps/edna',
            name: 'EDNA Bot',
            component: EDNA,
            meta: {
                requiresAuth: false,
                hideForAuth: false,
            }
        },
        {
            path: '/apps/analytics-planner/:doc_id?',
            name: 'Analytics Planner',
            component: AnalyticsPlanner,
            beforeEnter: ifAuthenticated,
            meta: {
                requiresAuth: false,
                hideForAuth: false,
            },
            children: [
                {
                    path: 'task/:id',
                    name: 'Planner task',
                    component: TaskPopup,
                }
            ]
        },
        {
            path: '/apps/priorities-matrix/:doc_id?',
            name: 'Priorities Matrix',
            component: PrioritiesMatrix,
            beforeEnter: ifAuthenticated,
            meta: {
                requiresAuth: false,
                hideForAuth: false,
            },
            children: [
                {
                    path: 'idea/:id',
                    name: 'Priorities idea',
                    component: PrioritiesTaskPopup,
                }
            ]
        },
        {
            path: '/apps/project-share/:doc_id?',
            name: 'Project Share',
            component: ProjectShare,
            beforeEnter: ifAuthenticated,
            meta: {
                requiresAuth: true,
                hideForAuth: false,
            },
        },
        {
            path: '/apps/model-planner/:doc_id?',
            name: 'Data Model Planner',
            component: ModelPlanner,
            beforeEnter: ifAuthenticated,
            meta: {
                requiresAuth: true,
                hideForAuth: false,
            },
            children: [
                {
                    path: 'task/:id',
                    name: 'Model Planner Task',
                    component: ModelTaskPopup,
                }
            ]
        },
        {
            path: '/apps/pipeline-planner/:doc_id?',
            name: 'Data Pipeline Planner',
            component: PipelinePlanner,
            beforeEnter: ifAuthenticated,
            meta: {
                requiresAuth: true,
                hideForAuth: false,
            },
            children: [
                {
                    path: 'task/:id',
                    name: 'Pipeline Planner Task',
                    component: TaskPopup,
                }
            ]
        },
        {
            path: '/apps/m-code',
            name: "M Code",
            component: Document
        },
        {
            path: '/apps/raw-code',
            name: "RAW Code",
            component: Document
        },
        {
            path: '/apps/python-code',
            name: "PythonCode",
            component: Document
        },
        {
            path: '/apps/r-code',
            name: "RCode",
            component: Document
        },
        {
            path: '/apps/notepad',
            name: "Notepad",
            component: Document
        },
        {
            path: '/apps/PowerBiTheme',
            name: "Power Bi Theme",
            component: Document
        },
        {
            path: '/apps/power-bi-theme-generator',
            name: "PowerBiThemes",
            component: PowerBiTheme
        },
        {
            path: '/apps/playlist/:doc_id?',
            name: 'Playlist',
            component: Playlist,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/teams',
            name: 'Teams',
            component: Teams,
            beforeEnter: ifFreeUser,
            meta: {
                svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n' +
                    '                        <g>\n' +
                    '                            <g>\n' +
                    '                                <g>\n' +
                    '                                    <path\n' +
                    '                                        d="M0 9a9 9 0 1 1 18 0A9 9 0 0 1 0 9zm9 7.615c1.958 0 3.744-.739 5.093-1.953-.302-.268-.72-.481-1.315-.695a17.32 17.32 0 0 0-.348-.12l-.356-.12c-1.288-.435-1.868-.786-2.118-1.608a2.193 2.193 0 0 1 .077-1.496c.122-.285.31-.54.543-.735.66-.596.962-1.206.962-2.119 0-1.54-1.181-2.692-2.538-2.692-1.374 0-2.538 1.125-2.538 2.692 0 .912.295 1.506.923 2.1a2.053 2.053 0 0 1 .668 2.218c-.218.809-.782 1.156-2.019 1.579l-.411.139c-.16.054-.285.098-.404.142-.587.217-1.008.438-1.313.714A7.587 7.587 0 0 0 9 16.615zM16.615 9a7.615 7.615 0 1 0-13.652 4.643c.452-.415 1.03-.72 1.777-.995.132-.05.268-.097.438-.154l.409-.138c.797-.273 1.08-.447 1.148-.69l.007-.03a.708.708 0 0 0-.054-.48.835.835 0 0 0-.22-.25c-.921-.869-1.391-1.813-1.391-3.137 0-2.342 1.795-4.077 3.923-4.077 2.114 0 3.923 1.765 3.923 4.077 0 1.328-.482 2.3-1.439 3.164a.62.62 0 0 0-.178.235.856.856 0 0 0-.028.537c.07.234.376.42 1.238.71l.355.119c.146.049.262.09.376.13.76.274 1.338.57 1.79.98A7.582 7.582 0 0 0 16.614 9z"/>\n' +
                    '                                </g>\n' +
                    '                            </g>\n' +
                    '                        </g>\n' +
                    '                    </svg>'
            },
            children: [
                {
                    path: 'create',
                    name: 'Create Team Intro',
                    component: Intro,
                },
                {
                    path: 'create-team',
                    name: 'Create Team',
                    component: CreateTeam,
                },
                {
                    path: 'manage',
                    name: 'Team Management',
                    component: TeamIndex,
                },
                {
                    path: 'join',
                    name: 'Team Join',
                    component: TeamJoin,
                },
                {
                    path: 'switch',
                    name: 'Switch Team',
                    component: SwitchTeam
                },
                {
                    path: ':uuid',
                    name: 'Team Member Join',
                    component: TeamMemberJoin,
                }
            ]
        },
        {
            path: '/projects',
            name: 'Projects',
            component: Projects,
            beforeEnter: ifFreeUser,
            meta: {
                svg: '<svg style="top: 20px" width="18" height="14" xmlns="http://www.w3.org/2000/svg"><path d="M2.25 1.5a.75.75 0 00-.75.75v9c0 .414.336.75.75.75h13.5a.75.75 0 00.75-.75V4.5a.75.75 0 00-.75-.75h-7.5a.748.748 0 01-.53-.22L5.91 1.72a.75.75 0 00-.532-.22H2.25zM0 2.25A2.25 2.25 0 012.25 0h3.128c.597 0 1.17.237 1.592.66l1.59 1.59h7.19A2.25 2.25 0 0118 4.5v6.75a2.25 2.25 0 01-2.25 2.25H2.25A2.25 2.25 0 010 11.25v-9z"  fill-rule="evenodd"/></svg>'
            },
            children: [
                {
                    path: 'create',
                    name: 'Create Project Intro',
                    component: CreateIntro,
                },
                {
                    path: 'create-project',
                    name: 'Create Project',
                    component: CreateProjectForm,
                },
                {
                    path: 'manage',
                    name: 'Project Management',
                    component: ProjectManagement,
                },
                {
                    path: 'add-document',
                    name: 'Add Project Document',
                    component: AddDocument,
                },
                {
                    path: ':id',
                    name: 'Project View',
                    component: ProjectView,
                },
            ]
        },
        {
            path: '/learn',
            name: 'Learn',
            component: Learn,
            meta: {
                svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 15">\n' +
                    '                        <g>\n' +
                    '                            <g>\n' +
                    '                                <g>\n' +
                    '                                    <path\n' +
                    '                                        d="M16.299 9.697a.23.23 0 0 0 .316-.214V2.979a.23.23 0 0 0-.316-.214L13.385 3.93v4.601zM2.539 0h8.307a2.539 2.539 0 0 1 2.537 2.44l2.402-.961A1.615 1.615 0 0 1 18 2.979v6.504a1.615 1.615 0 0 1-2.215 1.5l-2.402-.961a2.539 2.539 0 0 1-2.537 2.44H2.538A2.538 2.538 0 0 1 0 9.923V2.538A2.538 2.538 0 0 1 2.538 0zm0 1.385c-.638 0-1.154.516-1.154 1.153v7.385c0 .637.516 1.154 1.153 1.154h8.308c.637 0 1.154-.517 1.154-1.154V2.538c0-.637-.517-1.153-1.154-1.153z"/>\n' +
                    '                                </g>\n' +
                    '                            </g>\n' +
                    '                        </g>\n' +
                    '                    </svg>'
            }
        },
        {
            path: '/community/join',
            name: 'Join Community',
            component: Community
        },
        {
            path: '/manage-account',
            name: 'Manage Account',
            component: ProfileEdit
        },
        {
            path: '/require-login',
            name: 'Require login',
            component: RequireLoginMessage,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/documents-limit',
            name: 'Documents Limit',
            component: DocumentLimitReached,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/feature-locked',
            name: 'Feature Locked',
            component: FeatureLocked,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/subscription-plans',
            name: 'Subscription Plans',
            component: SubscriptionPlans,
        },
        {
            path: '/switch-personal-space',
            name: 'Personal Space Switch',
            component: SwitchToPersonalSpace,
        }


    ],
    linkActiveClass: "active",
});

// 
router.beforeEach(async (to, from, next) => {
    if (to.name == 'Subscription Plans') {
        window.open('https://enterprisedna.co/pricing', '_self')
        return 
    }
    next()
    // Promise.all([store.dispatch("checkAuth")]).then(next)
});

// router.beforeEach((to, from, next) => {
//
//             if(to.meta.requiresAuth && !store.getters.isAuthenticated){
//                 next('/login');
//             } else if(to.meta.hideForAuth && store.getters.isAuthenticated){
//                 next('/');
//             } else {
//                 next();
//             }
//         }
//
// });


export default router;
